<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    
    <!-- SnackBar for Feedback -->
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <!-- Delete Confirmation Dialogue -->
    <v-dialog v-model="deleteDialogue" width="400">
      <v-card style="border-radius: 12px; padding: 12px;">
        <v-card-title class="pb-2" style="font-family: poppinssemibold; font-size: 16px; word-break: break-word;">
          Delete Product?
        </v-card-title>
        <v-card-text style="font-family: poppinsregular; font-size: 14px; color: #555;">
          Are you sure you want to delete <strong>{{ storage.productname }}</strong>? This action cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#8d8d8d" style="font-family: poppinsmedium;" @click="deleteDialogue = false">Cancel</v-btn>
          <v-btn depressed color="#ff1313" dark style="font-family: poppinsmedium; border-radius: 8px;" @click="deleteProduct">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Redesigned Product Card Layout -->
    <v-card
      flat
      outlined
      class="product-card"
      style="border-radius: 12px; border: 1px solid #eaeaea; background: #fff; cursor: pointer; transition: all 0.3s ease; height: 100%;"
      @click="navigateToDetail"
    >
      <v-layout align-center justify-space-between style="padding: 16px; height: 100%;">
        <!-- Image & Info Group -->
        <v-layout align-center style="max-width: calc(100% - 90px);">
          <!-- Image -->
          <div style="background-color: #fafafa; border-radius: 10px; border: 1px solid #eaeaea; padding: 4px; flex-shrink: 0; width: 70px; height: 70px; display: flex; align-items: center; justify-content: center;">
            <v-img
              v-if="storage.photos && storage.photos.length > 0"
              :src="baseURL + 'u/' + storage.photos[0]"
              aspect-ratio="1"
              contain
              max-width="62px"
              max-height="62px"
              style="border-radius: 6px;"
            ></v-img>
            <v-img
              v-else
              src="./../../../assets/noimg.png"
              aspect-ratio="1"
              contain
              max-width="62px"
              max-height="62px"
              style="border-radius: 6px;"
            ></v-img>
          </div>

          <!-- Title, Category and Price -->
          <div class="pl-3 text-left" style="min-width: 0; flex: 1;">
            <span
              style="font-family: poppinssemibold; font-size: 14px; color: #1c1c1c; display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; line-height: 1.3; margin-bottom: 2px;"
              :title="storage.productname"
            >
              {{ storage.productname }}
            </span>

            <div style="margin-bottom: 4px;" v-if="storage.category && (storage.category.name || (storage.category[0] && storage.category[0].name))">
              <v-chip x-small color="#eefaf3" text-color="#3ea56e" style="font-family: poppinsmedium; font-size: 10px; padding: 0 6px; height: 18px;">
                {{ storage.category.name || storage.category[0].name }}
              </v-chip>
            </div>

            <div style="display: flex; align-items: center; margin-top: 2px;">
              <template v-if="storage.offerPrice && storage.offerPrice < storage.price">
                <span style="font-family: poppinssemibold; font-size: 13px; color: #3ea56e; margin-right: 6px;">
                  ₹{{ storage.offerPrice }}
                </span>
                <span style="font-family: poppinsregular; font-size: 11px; color: #8d8d8d; text-decoration: line-through;">
                  ₹{{ storage.price }}
                </span>
              </template>
              <template v-else>
                <span style="font-family: poppinssemibold; font-size: 13px; color: #1c1c1c;">
                  ₹{{ storage.price }}
                </span>
              </template>
            </div>
          </div>
        </v-layout>

        <!-- Actions -->
        <div style="display: flex; align-items: center; flex-shrink: 0;" @click.stop>
          <!-- Edit Button -->
          <v-btn
            icon
            small
            outlined
            color="#3ea56e"
            class="mr-2"
            style="border-color: #d0edd7; width: 32px; height: 32px; border-radius: 50%;"
            :to="'/Seller/Product/Edit/' + storage._id"
            title="Edit Product"
            @click.native.stop
          >
            <v-icon size="16">mdi-pencil-outline</v-icon>
          </v-btn>

          <!-- Delete Button -->
          <v-btn
            icon
            small
            outlined
            color="#ff1313"
            style="border-color: #ffd0d0; width: 32px; height: 32px; border-radius: 50%;"
            @click.stop="deleteDialogue = true"
            title="Delete Product"
          >
            <v-icon size="16">mdi-delete-outline</v-icon>
          </v-btn>
        </div>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ProductItem",
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      deleteDialogue: false,
    };
  },
  methods: {
    navigateToDetail() {
      this.$router.push("/Seller/Product/" + this.storage._id);
    },
    deleteProduct() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/product/delete",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.storage._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Product Deleted Successfully";
            this.showSnackBar = true;
            this.deleteDialogue = false;
            this.$emit("stepper", {
              getData: true,
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.product-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease !important;
}
.product-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05) !important;
  border-color: #3ea56e !important;
}
</style>
